import { TipologiasInterface } from "./tipologias.model"

export interface formularioRegistroBienCultural{
    nombre: string,
    tipoDeBien: number,
    tipoPropiedad:number
    propietarioId: number,
    coleccion:TipologiasInterface
    seccion:number
    departamento:TipologiasInterface
    municipio:TipologiasInterface
    titular:number
    finca:string
    folio:string
    libro:string
    propietarioNombre:string
    nombrePoseedor:string
}


export class RegistroBienCulturalDTO {
    coleccionistaId: number
    propietario:string
    tipoBien: TipoBien
    tipoPropiedad:TipologiasInterface
    nombre: string
    seccion: Seccion

    constructor(myForm:formularioRegistroBienCultural){
  
    this.coleccionistaId = myForm.propietarioId;

    this.propietario = myForm.propietarioNombre;

    this.tipoBien = { tipologiaId: myForm.tipoDeBien, tipologiaPadreId: 0, descripcion: '', valor1: '', valor2: '', valor3: '', tipologias:null };

    this.tipoPropiedad= { tipologiaId: myForm.tipoPropiedad, tipologiaPadreId: 0, descripcion: '', valor1: '', valor2: '', valor3: '', tipologias:null };

    this.nombre = myForm.nombre;

    this.seccion = { tipologiaId: myForm.seccion, tipologiaPadreId: 0, descripcion: '', valor1: '', valor2: '', valor3: '', tipologias:null };
  }

    


  }
  
  export interface TipoBien {
    tipologiaId: number
    tipologiaPadreId: number
    descripcion: string
    valor1: string
    valor2: string
    valor3: string
    tipologias: any
  }
  
  export interface Seccion {
    tipologiaId: number
    tipologiaPadreId: number
    descripcion: string
    valor1: string
    valor2: string
    valor3: string
    tipologias: any
  }
  